// extracted by mini-css-extract-plugin
export var wrapper = "CubesPyramid-module--wrapper--3zz3J";
export var wrapper__container = "CubesPyramid-module--wrapper__container--2nTnH";
export var cube = "CubesPyramid-module--cube--3gFbb";
export var animated = "CubesPyramid-module--animated--2M9Ep";
export var rotation = "CubesPyramid-module--rotation--1Plgo";
export var translateContainer = "CubesPyramid-module--translateContainer--HkjX3";